import type { MailFolder } from 'owa-graph-schema';
import getRootFolderForFolderTree from './getRootFolderForFolderTree';
import { ARCHIVE_FOLDER_ROOT_DISTINGUISHED_ID } from 'owa-folders-constants';
import type { MailboxInfo } from 'owa-client-types';
import getSharedFolderArchiveMailboxInfo from './getSharedFolderArchiveInformation';
import { isMailboxSharedResourceArchive } from 'owa-account-shared-mailbox-utils';

/**
 * Archive mailbox folder tree root folder selector
 * @param mailboxInfo identifies the mailbox uniquely
 */
export default function getArchiveFolderTreeRootFolder(
    mailboxInfo: MailboxInfo
): MailFolder | undefined {
    let id: string = ARCHIVE_FOLDER_ROOT_DISTINGUISHED_ID;
    if (mailboxInfo.type == 'SharedMailbox') {
        const archiveMailboxInfo = getSharedFolderArchiveMailboxInfo(mailboxInfo);
        if (archiveMailboxInfo) {
            id = archiveMailboxInfo.mailboxSmtpAddress;
        }
    } else if (isMailboxSharedResourceArchive(mailboxInfo)) {
        id = mailboxInfo.mailboxSmtpAddress;
    }
    return getRootFolderForFolderTree(id, mailboxInfo);
}
